/**
 * 
 * Right.js
 * 
 */

import React, { Component } from 'react'
import { Container } from 'react-bootstrap';




export default class Right extends Component {
    
    static displayName = Right.name;
    
    render() {
    
        return (
    
            <Container style={{ backgroundColor: '', paddingBottom: '0px',  height: "140%" }}>

                
                <img
                src='/assets/image/home.png'
                height="95%"
                alt="home"
                />

            </Container>

        );
    
    }


}
